export default __webpack_public_path__ + "static/media/V380_RoHS.e9726ed9.pdf";